import React from 'react';
const links = ['Terms of Service', 'Privacy Policy', 'Refund Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-90" data-mp="3gg10u7y865zr">
      <div className="mx-auto max-w-5xl text-center" data-id="element-91" data-mp="32num8qaq072f">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-92" data-mp="32pffmclatjyp">
          Math Ready
        </p>
        <nav aria-label="Footer" data-id="element-93" data-mp="36nd5ziqt2c3o">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-94" data-mp="3ueik9th3kwbv">
            {links.map(link => <li key={link} data-id="element-95" data-mp="36mskisw8wry">
                <a href="#offer" className="transition-colors hover:text-brand" data-id="element-96" data-mp="3lelz41tx2flk">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-97" data-mp="29z6t68jqcdeb">
          © 2026 Math Ready. All rights reserved.
        </p>
      </div>
    </footer>;
}